import React, { Dispatch, SetStateAction, useState, useEffect } from 'react'
import { IDiamond } from 'types/diamond.types'
import CheckboxesSelector from '../CheckboxesSelector'

const TableHeader: React.FC<{
  data: IDiamond[]
  loading: boolean
  itemsToCompare: Partial<IDiamond>[]
  activeRadio: Number
  setActiveRadio: Dispatch<SetStateAction<number>>
}> = ({ data, loading, itemsToCompare, activeRadio, setActiveRadio }) => {
  const [checked, setChecked] = useState(false)
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (activeRadio !== 3 && itemsToCompare.length > 0) {
      setChecked(true)
      setActiveRadio(3)
    } else {
      setChecked(false)
      setActiveRadio(1)
    }
  }

  useEffect(() => {
    if (itemsToCompare.length > 0 && activeRadio === 3 && checked === false) {
      setChecked(true)
    } else if (itemsToCompare.length === 0 && activeRadio !== 1) {
      setChecked(false)
      setActiveRadio(1)
    }
  }, [
    itemsToCompare.length,
    activeRadio,
    data,
    loading,
    checked,
    setActiveRadio,
  ])

  return (
    <>
      <div>
        <div className="font-medium">
          <div className="bg-white">
            <div className="flex flex-row items-center gap-1 mb-6">
              <CheckboxesSelector />
              <div
                className={
                  itemsToCompare?.length > 0
                    ? 'w-auto border border-accent-1 rounded-full px-4 py-1 flex-row items-center hidden md:flex'
                    : 'w-auto border border-accent-1 rounded-full px-4 py-1 flex-row items-center hidden md:flex'
                }
              >
                <input
                  type="checkbox"
                  id="comparison"
                  onChange={(e) => {
                    handleOnChange(e)
                  }}
                  checked={checked}
                  className={
                    itemsToCompare?.length > 0
                      ? 'mr-2 cursor-pointer focus:ring focus:ring-primary text-accent-9'
                      : 'mr-2'
                  }
                />
                <label htmlFor="comparison">
                  <span className="text-sm font-normal text-gray-dark flex flex-row items-center cursor-pointer">
                    <p className="pr-2">Compare</p>
                    <p>({itemsToCompare.length})</p>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TableHeader
